import { render } from "./CreateNewFolder.vue?vue&type=template&id=19a85a77"
const script = {}

import exportComponent from "/Volumes/Storage/WebDevelopment/Fintax/new-gitlab/pajak.io/frontend-library-component-v1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__